module.exports = __webpack_public_path__ + "img/dashboard-bg.a65066a0.jpg";